import convertPValueToNumber from '../convertPValueToNumber/convertPValueToNumber';
/**
 * Method which validate PValue by this pattern (0 ≤ p-value ≤ 1)
 * @param Pvalue - PValue, value which user put in input
 * @return boolean value, which means validation status
 */
const validatePValue = (Pvalue) => {
    const value = convertPValueToNumber(Pvalue);
    if (value === null) {
        return true;
    }
    // eslint-disable-next-line no-restricted-globals
    if (isNaN(value)) {
        return false;
    }
    return value >= 0 && value <= 1;
};
export default validatePValue;
